import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class UnifiedAddressFormAnalytics extends BaseAnalytics {
    constructor(category = 'unified_address_form') {
        super();
        this.category = category;
    }

    inputStarted() {
        this.send('started_address_verification');
    }

    selectAddress() {
        this.send('selected_address');
    }

    checkClicked() {
        this.send('click_address_verification');
    }

    verificationSuccess() {
        this.send('address verification', 'success');
    }

    verificationFailed(reason?: string) {
        const message = reason
            ? `error_${reason}`
            : 'error';

        this.send('address verification', message);
    }
}

export default UnifiedAddressFormAnalytics;
